export default __webpack_public_path__ + "static/media/ic_note.ce0b11d9.svg";